import { useTranslation } from 'react-i18next'
import NoTrackingPill from '~/pages/scorm/components/NoTrackingPill'

type IProps = {
  sessionName?: string | null
  /** Rang de l'étape jouée (0 = première), s'il est connu. */
  stepPosition?: number | null
  totalSteps: number
  impersonating: boolean
}

/** Le contenu du bandeau du lecteur apprenant : parcours, étape, mode consultation. */
function LearnerPlayerHeader({ sessionName, stepPosition, totalSteps, impersonating }: IProps) {
  const { t } = useTranslation()

  return (
    <>
      {sessionName && (
        // Le titre de l'écran (RGAA 9.1) : le lecteur n'en avait aucun.
        <h1 className="truncate text-sm font-normal text-muted-foreground">
          {sessionName}
          {/* Le rang n'apparaît que sur un vrai parcours : « 2/5 » à côté
              d'un parcours à un module n'informerait de rien. */}
          {totalSteps > 1 && stepPosition != null && (
            <span className="ml-2 text-muted-foreground">
              {t('scorm.player.step', { current: stepPosition + 1, total: totalSteps })}
            </span>
          )}
        </h1>
      )}
      {impersonating && (
        <NoTrackingPill>{t('scorm.impersonate.noTracking')}</NoTrackingPill>
      )}
    </>
  )
}

export default LearnerPlayerHeader
